import React,{useContext} from 'react';
import { 
  Card, 
  CardActionArea, 
  Typography, 
  Box, 
  Avatar 
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AuthContext from "flexbiz-core/components/auth/Context";

export default function BrokerTeaserWidget() {
  const history = useHistory();
  const context = useContext(AuthContext);
  return (
    <Card 
      sx={{ 
        width: '100%', // Đảm bảo full width trên mobile
        height:"100%",
        borderRadius: 3, 
        // Sử dụng gradient màu cam/vàng để tạo cảm giác năng lượng, tài lộc
        background: 'linear-gradient(135deg, #FF8008 0%, #FFA03A 100%)', 
        color: 'white',
        boxShadow: '0 8px 16px rgba(255, 128, 8, 0.25)',
      }}
    >
      <CardActionArea 
        onClick={() =>{
            /*const group_name = (context.appInfo.par?.group?.group_name||"").toLowerCase();
            if(group_name.indexOf("môi giới")<0){
                return context.alert("Tính năng này chỉ dành cho môi giới. Hãy đăng ký một tài khoản môi giới và bắt đầu sử dụng.",null,"red");
            }*/
            history.push('/broker')} 
        } 
        sx={{ p: 2.5 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          
          {/* Icon nổi bật bên trái */}
          <Avatar 
            sx={{ 
              bgcolor: 'rgba(255, 255, 255, 0.25)', 
              color: 'white', 
              width: 56, 
              height: 56, 
              mr: 2 
            }}
          >
            <RocketLaunchIcon fontSize="medium" />
          </Avatar>
          
          {/* Nội dung miêu tả */}
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.2, mb: 0.5 }}>
              Góc Môi Giới & CTV
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.95, fontSize: '0.85rem' }}>
              Nhận ngay hoa hồng tới <b>5%</b> và xây dựng mạng lưới thu nhập thụ động từ <b>1%</b> trọn đời. Khám phá ngay!
            </Typography>
          </Box>

          {/* Mũi tên điều hướng bên phải */}
          <ArrowForwardIosIcon sx={{ fontSize: 16, opacity: 0.8, ml: 1.5 }} />
          
        </Box>
      </CardActionArea>
    </Card>
  );
}